﻿import $ from 'jquery';
import animation from './filterAnimations.js';

function initFiltersMainFilteringSystem() { 
    const tabs = document.querySelectorAll('.tabTypes li');
    const sections = document.querySelectorAll('.section');
    const filters = document.querySelectorAll('.filter');
    const resetButton = document.getElementById('filter-reset');
    const searchQuery = document.getElementById('search-query');

    //To determine if we scroll the user, we need to know window width
    const windowWidth = $(window).width();
    //Then we need to figure out which ID we're using since this same filtering is used on 3 different pages
    let filterScrollSection;
    if (window.location.pathname.includes('resources') && $('#resources-list').length) {
        filterScrollSection = $('#resources-list');
    }
    else if (window.location.pathname.includes('leadership-courses') && $('#courses-list').length) {
        filterScrollSection = $('#courses-list');
    }
    else if (window.location.pathname.includes('events') && $('#global-list').length) {
        filterScrollSection = $('#global-list');
    }
    else if (window.location.pathname.includes('media') && $('#media-list').length) {
        filterScrollSection = $('#media-list');
    }
    else if (window.location.pathname.includes('workshops') && $('#workshops-list').length) {
        filterScrollSection = $('#workshops-list');
    }

    let activeSection = null;

    const appliedFilters = {
        type: [],
        topic: [],
        level: [],
        products: [],
        learning_format: [],
        format: [],
        country: [],
        searchTerm: '',
        updateTabCounters: function () {
            let tabsToBeUpdated = $('.tabTypes > li');
            for (var i = 0; i < tabsToBeUpdated.length; i++) {
                if(tabsToBeUpdated[i].dataset.value == 'type') {
                    $('.tabTypes > li[data-value="type"] > a > .tabCounter').text(`${this.type.length != 0 ? '(' + this.type.length + ')' : ''}`)
                }
                else if(tabsToBeUpdated[i].dataset.value == 'topic') {
                    $('.tabTypes > li[data-value="topic"] > a > .tabCounter').text(`${this.topic.length != 0 ? '(' + this.topic.length + ')' : ''}`)
                }
                else if (tabsToBeUpdated[i].dataset.value == 'level') {
                    $('.tabTypes > li[data-value="level"] > a > .tabCounter').text(`${this.level.length != 0 ? '(' + this.level.length + ')' : ''}`)
                }
                else if (tabsToBeUpdated[i].dataset.value == 'products') {
                    $('.tabTypes > li[data-value="products"] > a > .tabCounter').text(`${this.products.length != 0 ? '(' + this.products.length + ')' : ''}`)
                }
                else if (tabsToBeUpdated[i].dataset.value == 'learning_format') {
                    $('.tabTypes > li[data-value="learning_format"] > a > .tabCounter').text(`${this.learning_format.length != 0 ? '(' + this.learning_format.length + ')' : ''}`)
                }
                else if (tabsToBeUpdated[i].dataset.value == 'format') {
                    $('.tabTypes > li[data-value="format"] > a > .tabCounter').text(`${this.format.length != 0 ? '(' + this.format.length + ')' : ''}`)
                }
                else if (tabsToBeUpdated[i].dataset.value == 'country') {
                    $('.tabTypes > li[data-value="country"] > a > .tabCounter').text(`${this.country.length != 0 ? '(' + this.country.length + ')' : ''}`)
                }
            }
        },
        addValue: function (typeOfFilter, value, buildParamaters) {
            if (typeOfFilter === "type") {
                this.type.push(value);
            }
            else if (typeOfFilter === "topic") {
                this.topic.push(value);
            }
            else if (typeOfFilter === "level") {
                this.level.push(value);
            }
            else if (typeOfFilter === "products") {
                this.products.push(value);
            }
            else if (typeOfFilter === "learning_format") {
                this.learning_format.push(value);
            }
            else if (typeOfFilter === "format"){
                this.format.push(value)
            }
            else if (typeOfFilter === "country") {
                this.country.push(value)
            }

            //Update Label
            this.updateTabCounters();

            if (buildParamaters === true && buildParamaters != undefined) {
                this.buildURLParameters();
            }


        },
        removeValue: function (typeOfFilter, value, buildParamaters) {
            if (typeOfFilter === "type") {
                const indexOfValue = this.type.indexOf(value);
                this.type.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "topic") {
                const indexOfValue = this.topic.indexOf(value);
                this.topic.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "level") {
                const indexOfValue = this.level.indexOf(value);
                this.level.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "products") {
                const indexOfValue = this.level.indexOf(value);
                this.products.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "learning_format") {
                const indexOfValue = this.learning_format.indexOf(value);
                this.learning_format.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "format") {
                const indexOfValue = this.format.indexOf(value);
                this.format.splice(indexOfValue, 1);
            }
            else if (typeOfFilter === "country") {
                const indexOfValue = this.country.indexOf(value);
                this.country.splice(indexOfValue, 1);
            }

            //Update Label
            this.updateTabCounters();

            if (buildParamaters === true && buildParamaters != undefined) {
                this.buildURLParameters();
            }

        },
        addSearchTerm: function (value) {
            this.searchTerm = value;
        },
        clear: function () {
            while (this.topic.length) {
                this.topic.pop();
            }
            while (this.type.length) {
                this.type.pop();
            }
            while (this.level.length) {
                this.level.pop();
            }
            while (this.products.length) {
                this.products.pop();
            }
            while (this.learning_format.length) {
                this.learning_format.pop();
            }
            while (this.format.length) {
                this.format.pop();
            }
            while (this.country.length) {
                this.country.pop();
            }
            this.searchTerm = null;
            this.buildURLParameters();
            this.updateTabCounters();
        },
        bundleData: function (controller) {
            let dataToPost = '';
            switch (controller) {
                case 'resources':
                    dataToPost = JSON.stringify({
                        'types': appliedFilters.type.toString(),
                        'topics': appliedFilters.topic.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                case 'courses':
                    dataToPost = JSON.stringify({
                        'topics': appliedFilters.topic.toString(),
                        'levels': appliedFilters.level.toString(),
                        'products': appliedFilters.products.toString(),
                        'learning_format': appliedFilters.learning_format.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                case 'global':
                    dataToPost = JSON.stringify({
                        'country': appliedFilters.country.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                case 'workshops':
                    dataToPost = JSON.stringify({
                        'country': appliedFilters.country.toString(),
                        'types': appliedFilters.type.toString(),
                        'format': appliedFilters.format.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                case 'webinars':
                    dataToPost = JSON.stringify({
                        'country': appliedFilters.country.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                case 'media':
                    dataToPost = JSON.stringify({
                        'country': appliedFilters.country.toString(),
                        'search': appliedFilters.searchTerm
                    })
                    return dataToPost;
                default:
                    dataToPost = null;
            }
        },
        buildURLParameters: function () {
            
            let urlStringParameters = `?`;
            if (appliedFilters.type.length != 0) {
                urlStringParameters += `type=`
                for (let i = 0; i < appliedFilters.type.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.type[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.type[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.topic.length != 0) {
                urlStringParameters += `topic=`
                for (let i = 0; i < appliedFilters.topic.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.topic[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.topic[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.level.length != 0) {
                urlStringParameters += `level=`
                for (let i = 0; i < appliedFilters.level.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.level[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.level[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.products.length != 0) {
                urlStringParameters += `products=`
                for (let i = 0; i < appliedFilters.products.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.products[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.products[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.learning_format.length != 0) {
                urlStringParameters += `learning_format=`
                for (let i = 0; i < appliedFilters.learning_format.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.learning_format[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.learning_format[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.format.length != 0) {
                urlStringParameters += `format=`
                for (let i = 0; i < appliedFilters.format.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.format[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.format[i]}`;
                    }
                }
                urlStringParameters += '&';
            }
            if (appliedFilters.country.length != 0) {
                urlStringParameters += `country=`
                for (let i = 0; i < appliedFilters.country.length; i++) {
                    if (i === 0) {
                        urlStringParameters += appliedFilters.country[i];
                    }
                    else {
                        urlStringParameters += `,${appliedFilters.country[i]}`;
                    }
                }
                urlStringParameters += '&';
            }

            let cutURL = urlStringParameters.replace(/\&$/, '');
            window.history.pushState(null, null, cutURL);
        }
    };

    //Remove the css class 'filter--active' from ALL tabs and sections
    const removeActive = () => {
        tabs.forEach(tab => {
            tab.classList.remove('tab--active');
            let chevronToFlip = tab.querySelector('a i');
            if (!chevronToFlip) {
                chevronToFlip = tab.querySelector('a svg');
            }
            chevronToFlip.classList.remove('chevronRotate');
        });
        sections.forEach(section => {
            section.classList.remove('section--active');
        });
    }

    //Add the css class 'tab--active' and 'section--active' element that is current active. Flip chevron of active tab.
    //Also, set global variable
    const addActive = tab => {
        activeSection = tab.getAttribute('data-value');
        tab.classList.add('tab--active');
        const href = tab.querySelector('a').getAttribute('href');
        const matchingSection = document.querySelector(href);
        matchingSection.classList.add('section--active');

        let chevronToFlip = tab.querySelector('a i');
        if (!chevronToFlip) {
            chevronToFlip = tab.querySelector('a svg');
        }
        chevronToFlip.classList.add('chevronRotate');
    }

    //This grabs url query parameters
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);

        return (results !== null) ? results[1] || 0 : false;
    }
    //If we have a query string, then that needs to 
    //  1. grab that value and store it in a const
    //  2. find the filter that it matches and highlight it
    //  3. add that value to the applied filters type
    //  4. set type as the active section
    //  5. open up the type section
    //  TODO - Prefiltering by country for events. country=x will be the format. 
    if ($.urlParam('type') != false) {
        const returning_param_object = $.urlParam('type');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'type') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    if ($.urlParam('topic') != false) {
        const returning_param_object = $.urlParam('topic');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'topic') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    if ($.urlParam('country') != false) {
        const returning_param_object = $.urlParam('country');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'country') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    if ($.urlParam('learning_format') != false) {
        const returning_param_object = $.urlParam('learning_format');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'learning_format') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    if ($.urlParam('format') != false) {
        const returning_param_object = $.urlParam('format');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'format') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    if ($.urlParam('level') != false) {
        const returning_param_object = $.urlParam('level');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'level') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }
    if ($.urlParam('products') != false) {
        const returning_param_object = $.urlParam('products');

        if (returning_param_object.indexOf(',') > -1) {
            const unclean_params = returning_param_object.split(',');
            const cleaned_params = unclean_params.map(x => {
                return x.replace(/-/g, '_');
            });
            cleaned_params.forEach(cleaned => {
                filters.forEach(filter => {
                    const type = filter.getAttribute('data-type');
                    const value = filter.getAttribute('data-value');
                    if (value == cleaned) {
                        filter.classList.add('filter--active');
                        appliedFilters.addValue(type, value);
                    }
                })
            });
        }
        else {
            const cleaned_param = returning_param_object.replace(/-/g, '_');
            filters.forEach(filter => {
                const type = filter.getAttribute('data-type');
                const value = filter.getAttribute('data-value');
                if (value == cleaned_param) {
                    filter.classList.add('filter--active');
                    appliedFilters.addValue(type, value);
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-value') === 'products') {
                    removeActive();
                    addActive(tab);
                }
            })
        }
    }

    // Loop through the two tabs and add the event listeners that 
    // handle opening and closing the sections that the filters are in
    tabs.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();
            if (tab.getAttribute('data-value') === activeSection) {
                removeActive();
                activeSection = null;
            }
            else {
                removeActive();
                addActive(tab);
            }
        })
    });


    /*Filter stuff*/

    //Loop through each filter and
    // 1. Attach a click event listener
    // 2. toggle the 'filter--active' class that makes it turn blue
    // 3. grab the type and value of the filter
    // 4. If the filter is active pass it to the appliedFilters object, otherwise remove it
    // 5. Update the URL
    // 6. Perform ajax request
    // 7. update helps
    filters.forEach(filter => {
        filter.addEventListener('click', e => {
            filter.classList.toggle('filter--active');
            const type = filter.getAttribute('data-type');
            const value = filter.getAttribute('data-value');
            if (filter.classList.contains('filter--active')) {
                appliedFilters.addValue(type, value, true);
            }
            else {
                appliedFilters.removeValue(type, value, true);
            }


            const controller = determineController();
            const filterData = appliedFilters.bundleData(controller);

            performRequest('POST', filterData, `/${controller}/filter`);

        });
    });

    //loop through filters to remove active class. Also purge all filters from appliedFilters object
    const resetFilters = event => {
        event.preventDefault()
        filters.forEach(filter => {
            filter.classList.remove('filter--active');
        });
        appliedFilters.clear();

        //Make sure to hit the right controller here using your new determineController function
        const controller = determineController();
        //Should return null. Maybe remove? 
        const filterData = appliedFilters.bundleData(controller);


        //If we're on the resources page, reset the url. Otherwise don't bother. 
        if (controller === '') {
            window.history.pushState('', 'Resources | DDI', '/resources');
        }
        performRequest('POST', filterData, `/${controller}/filter`);
        $('#search-string').addClass('d-none');

        //Clear the query string
        let URL = window.location.href;
        const removeQueryURL = URL.split("?")[0];
        window.history.pushState({}, 'Resources', removeQueryURL);
    }

    //attach event listener to rest link
    resetButton.addEventListener('click', resetFilters);

    //If the user previously searched, then add it to applied filters. First check if searchQuery is null.
    if (searchQuery != null) {
        if (searchQuery.innerText != '') {
            appliedFilters.addSearchTerm(searchQuery.innerText);
        }
    }

    const determineController = () => {
        const filterContainer = document.getElementById('filterContainer');
        const controller = filterContainer.getAttribute('data-controller');
        return controller;
    }
    var ajaxLoadTimeout;
    const performRequest = (type, payload, url) => {
        $.ajax({
            url: url,
            type: type,
            beforeSend: function () {
                ajaxLoadTimeout = setTimeout(function () {
                    $("#loader-wrapper").show();
                }, 300);
                
            },
            data: payload ? payload : '',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            success: function (data) {
                const controller = determineController();
                $(`#${controller}-list`).html(data);
                clearTimeout(ajaxLoadTimeout);
                $("#loader-wrapper").hide();

                //If we're on a mobile device, and on the (resources/events/courses) page, scroll down. 
                if (windowWidth < 768 && filterScrollSection instanceof jQuery) {
                    $('html,body').animate({
                        scrollTop: filterScrollSection.offset().top + -25
                    });
                }

                //Finally, start the animation
                animation();
            },
            error: function (error) {
                console.log(error);
                clearTimeout(ajaxLoadTimeout);
                $("#loader-wrapper").hide()
            }
        });
    }
}

initFiltersMainFilteringSystem();